import type { FaireProductEntity } from "../../entity_types/product";

export const p_24sg49bqid: FaireProductEntity = {
  token: "p_24sg49bqid",
  type: "product",
  name: "Whisky Business Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b2d7be3715d95d9974bc9a301c90679a2c1a32da57a176060fa96a9d248ee63e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c71c7fedfc74d4c2e7eafb00195ed4ba2f409ae434017293bda1128138b8b5e0.jpeg",
    "https://cdn.faire.com/fastly/4598ed428c3142320e4427d9e19615a3a0ec69fa935f8c643b8b8485ac84fccb.jpeg",
    "https://cdn.faire.com/fastly/929b71c17ea433e1c8c31988519e8ffde6dc3273542b2a4068f9c68676641695.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:37.983Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
